import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';

import { analyticsMiddleware } from 'services/analytics/middleware';

import createReducer from '../reducers';
import history from '../../config/history';

export default function configureStore (initialState = {}) {
  const composeEnhancers = composeWithDevTools({});

  const middleware = [thunk, routerMiddleware(history), analyticsMiddleware];
  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  );

  return store;
}
